<template>
  <SfModalPortal
    modal-id="confirm-process-meeting-modal"
    size="s"
    @opened="openModal"
    @close="closeModal"
  >
    <template #title>{{ copy.title }}</template>

    <template #messages>
      <SfModalMessage variant="neutral" class="tw-mb-6">
        {{ copy.message }}
      </SfModalMessage>
    </template>

    <template #footer>
      <SfButtonDs variant="secondary" @click="closeModal">
        {{ copy.cancelButton }}
      </SfButtonDs>
      <SfButtonDs variant="primary" @click="handleConfirm">
        {{ copy.confirmButton }}
      </SfButtonDs>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import {
  SfModalMessage,
  SfModalPortal,
} from '@app/shared/vue/components/sf-modal'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfButtonDs } from '@silverfin/ui-components'
import { ref } from 'vue'

const I18n = useI18n()
const copy = {
  title: I18n.t('client_meetings.prepare.process_meeting_confirmation.title'),
  message: I18n.t(
    'client_meetings.prepare.process_meeting_confirmation.message'
  ),
  cancelButton: I18n.t('common.cancel'),
  confirmButton: I18n.t('client_meetings.prepare.process_meeting_button'),
}

const onConfirm = ref<() => void>()

function openModal(params: { onConfirm: () => void }) {
  onConfirm.value = params.onConfirm
}

function closeModal() {
  window.modalCitizen.closeModalPortal()
}

function handleConfirm() {
  closeModal()
  onConfirm.value?.()
}
</script>
